'use client';
import React, { useEffect, useRef } from 'react';

export default function QuoteSection() {
  const textRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    const el = textRef?.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            el.classList.add('scrubbed');
          }
        });
      },
      { threshold: 0.3 }
    );

    observer?.observe(el);
    return () => observer?.disconnect();
  }, []);

  return (
    <section className="py-28 md:py-40 px-6 md:px-12 bg-cream-dark relative overflow-hidden">
      <div className="max-w-5xl mx-auto text-center">
        <h2
          ref={textRef}
          className="font-serif scroll-scrub-text leading-[1.05] tracking-tight"
          style={{ fontSize: 'clamp(2rem, 5.5vw, 5rem)' }}>

          &quot;The New Town isn&apos;t just where we sell homes. It is where I call home and my favourite place to wake up to every morning.&quot;
        </h2>
        <div className="mt-10 flex justify-center">
          <div className="h-12 w-px bg-gradient-to-b from-sage to-transparent" />
        </div>
        <p className="mt-4 text-[12px] uppercase tracking-[0.2em] text-forest/40 font-medium">STEPHEN MACKENZIE · DIRECTOR AT CULLERTON'S

        </p>
      </div>
    </section>);

}